export default __webpack_public_path__ + "static/media/S3.b66add5f.svg";